module.exports = __webpack_public_path__ + "img/content3.0009bc13.png";